module.exports = __webpack_public_path__ + "img/semesterprogramm.ba0a485f.jpg";